import { render, staticRenderFns } from "./dialogStopJiyang.vue?vue&type=template&id=22dd07b8&scoped=true&"
import script from "./dialogStopJiyang.vue?vue&type=script&lang=js&"
export * from "./dialogStopJiyang.vue?vue&type=script&lang=js&"
import style0 from "./dialogStopJiyang.vue?vue&type=style&index=0&id=22dd07b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd07b8",
  null
  
)

export default component.exports